// Doctors roster — Healthie provider status + Zoom host identity + application status. Provider
// credentials (compliance metadata, not clinical data) live on the detail page.
import { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../api";
import { useAsync } from "../lib/useAsync";
import { shortId } from "../lib/format";
import { InviteStaff } from "../components/InviteStaff";
import { Loading, ErrorState, EmptyState, PageHeader, StatusBadge } from "../components/ui";

export function Doctors() {
  const api = useApi();
  const [inviting, setInviting] = useState(false);
  const { data, loading, error, reload } = useAsync(() => api.doctors(), []);
  if (loading && !data) return <Loading />;
  if (error) return <ErrorState message={error} />;
  const rows = data ?? [];

  return (
    <div className="page">
      <PageHeader
        title="Doctors"
        sub={`${rows.length} providers`}
        actions={
          <button className="pbtn pbtn--primary" onClick={() => setInviting((v) => !v)}>
            {inviting ? "Cancel" : "Add doctor"}
          </button>
        }
      />
      {inviting && (
        <InviteStaff role="doctor" onInvited={reload} onClose={() => setInviting(false)} />
      )}
      <div className="ptbl-wrap">
        <table className="ptbl">
          <thead>
            <tr>
              <th>Name</th>
              <th>Specialty</th>
              <th>Healthie provider</th>
              <th>Zoom host</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((d) => (
                <tr key={d.id} className="ptbl-row">
                  <td>
                    <div className="ptbl-name">
                      <Link to={`/doctors/${d.id}`}>
                        {d.first_name} {d.last_name}
                      </Link>
                    </div>
                    <div className="ptbl-sub">{d.email}</div>
                  </td>
                  <td>{d.specialty ?? "—"}</td>
                  <td className="mono">{shortId(d.healthie_provider_id)}</td>
                  <td className="mono">{shortId(d.zoom_user_id)}</td>
                  <td>
                    <StatusBadge value={d.application_status} />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>
                  <EmptyState>No doctors yet.</EmptyState>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
